// extracted by mini-css-extract-plugin
module.exports = {"section":"Offer_section__3RLh9","stage":"Offer_stage__NAvfG","title":"Offer_title__2LdtV","text":"Offer_text__1MK02"};